import React from 'react';
import WebsiteNavbar from '../../components/WebsiteUI/WebsiteNavbar';
import WebsiteFooter from '../../components/WebsiteUI/WebsiteFooter';
import styles from './LegalPage.module.css';

const LegalPage = ({ title, children }) => {
  return (
    <>
      <WebsiteNavbar />
      <div className={styles.legal}>
        <div className={styles.legal__container}>
          <h1 className={styles.legal__title}>{title}</h1>
          <div className={styles.legal__content}>
            {children}
          </div>
        </div>
      </div>
      <WebsiteFooter />
    </>
  );
};

export default LegalPage;
